// Track click events
document.addEventListener('click', function(e) {
  const target = e.target;
  Shopify.analytics.publish('click', {
    clickElement: target.tagName,
    id: target.id,
    className: target.className,
    text: target.innerText,
    href: target.href,
    path: window.location.pathname,
    timestamp: new Date().toISOString(),
    x: e.clientX,
    y: e.clientY
  });
  // Check if clicked element has image-link class
  if (target.classList.contains('image-link')) {
    // Get the add to cart button wrapper and button
    const addToCartWrapper = target.nextElementSibling;
    const addToCartButton = addToCartWrapper?.querySelector('button');
    
    // Publish product click analytics
    Shopify.analytics.publish('select_item', {
      contextCustom: target.dataset.context,
      productSku: addToCartButton?.dataset?.sku,
      productPrice: addToCartButton?.dataset?.price,
      productId: addToCartButton?.dataset?.variantId,
      productTitle: addToCartButton?.dataset?.title,
      path: window.location.pathname,
    });
  }
});

// Track scroll events with percentage thresholds
const scrollThresholds = [25, 50, 75, 100];
const reachedThresholds = new Set();

document.addEventListener('scroll', function() {
  const scrollPosition = window.scrollY;
  const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
  const scrollPercentage = Math.round((scrollPosition / maxScroll) * 100);
  
  // Check if we've reached any threshold
  scrollThresholds.forEach(threshold => {
    if (scrollPercentage >= threshold && !reachedThresholds.has(threshold)) {
      // Mark this threshold as reached
      reachedThresholds.add(threshold);
      
      // Send the analytics event
      Shopify.analytics.publish('scroll_depth', {
        scrollDepth: scrollPosition,
        scrollPercentage: threshold,
        viewportHeight: window.innerHeight,
        pageHeight: document.documentElement.scrollHeight,
        path: window.location.pathname,
        timestamp: new Date().toISOString()
      });
    }
  });
});

// Reset thresholds on page change
document.addEventListener('DOMContentLoaded', function() {
  reachedThresholds.clear();
});

// Track Vimeo videos on the page
document.addEventListener('DOMContentLoaded', function() {
  // Find all Vimeo iframes on the page
  const vimeoIframes = Array.from(document.querySelectorAll('iframe[src*="vimeo.com"]'));
  
  if (vimeoIframes.length > 0) {
    // Load Vimeo Player API if not already loaded
    if (!window.Vimeo) {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.onload = initializeVimeoTracking;
      document.head.appendChild(script);
    } else {
      initializeVimeoTracking();
    }
  }
  
  function initializeVimeoTracking() {
    vimeoIframes.forEach((iframe, index) => {
      // Create a player instance
      const player = new Vimeo.Player(iframe);
      const videoId = iframe.src.match(/\/video\/(\d+)/)?.[1] || `unknown-${index}`;
      let videoTitle = iframe.title || '';
      
      // Get video title from Vimeo API
      player.getVideoTitle().then(title => {
        videoTitle = title || videoTitle;
      }).catch(() => {
        // If getVideoTitle fails, we'll use the iframe title or empty string
      });
      
      // Track when the video has loaded
      player.ready().then(() => {
        Shopify.analytics.publish('vimeo_loaded', {
          videoId: videoId,
          videoTitle: videoTitle,
          videoUrl: iframe.dataset.baseUrl
        });
      });
      
      // Track play events
      player.on('play', () => {
        Shopify.analytics.publish('vimeo_play', {
          videoId: videoId,
          videoTitle: videoTitle,
          videoUrl: iframe.dataset.baseUrl
        });
      });
      
      // Track pause events
      player.on('pause', () => {
        // Check if we're at the end of the video to avoid duplicate events
        // when the video ends naturally (which triggers both pause and ended)
        player.getCurrentTime().then(currentTime => {
          player.getDuration().then(duration => {
            // Only count as pause if we're not at the end (within 0.5 seconds of end)
            if (duration - currentTime > 0.5) {
              Shopify.analytics.publish('vimeo_pause', {
                videoId: videoId,
                videoTitle: videoTitle,
                videoUrl: iframe.dataset.baseUrl
              });
            }
          });
        });
      });
      
      // Track progress percentages
      const progressThresholds = [25, 50, 75];
      const reachedVideoThresholds = new Set();
      
      player.on('timeupdate', (data) => {
        player.getDuration().then(duration => {
          const percentage = Math.floor((data.seconds / duration) * 100);
          
          // Check if we've reached any threshold
          progressThresholds.forEach(threshold => {
            if (percentage >= threshold && !reachedVideoThresholds.has(threshold)) {
              // Mark this threshold as reached
              reachedVideoThresholds.add(threshold);
              
              // Send the analytics event
              Shopify.analytics.publish('vimeo_progress', {
                videoId: videoId,
                videoTitle: videoTitle,
                progressPercentage: threshold,
                currentTime: data.seconds,
                duration: duration,
                videoUrl: iframe.dataset.baseUrl
              });
            }
          });
        });
      });
      
      // Track video abandonment
      let isPlaying = false;
      
      player.on('play', () => {
        isPlaying = true;
      });
      
      player.on('pause', () => {
        isPlaying = false;
      });
      
      player.on('ended', () => {
        isPlaying = false;
        Shopify.analytics.publish('vimeo_complete', {
          videoId: videoId,
          videoTitle: videoTitle,
          videoUrl: iframe.dataset.baseUrl
        });
      });
      
      // Listen for page unload while video is playing
      window.addEventListener('beforeunload', () => {
        if (isPlaying) {
          player.getCurrentTime().then(currentTime => {
            player.getDuration().then(duration => {
              const percentage = Math.floor((currentTime / duration) * 100);
              
              // Send the analytics event
              Shopify.analytics.publish('vimeo_abandonment', {
                videoId: videoId,
                videoTitle: videoTitle,
                progressPercentage: percentage,
                currentTime: currentTime,
                duration: duration,
                videoUrl: iframe.dataset.baseUrl
              });
            });
          });
        }
      });
    });
  }
});

